module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/view/details-blocks/details-blocks.component.css
// module id = ./src/app/view/details-blocks/details-blocks.component.css
// module chunks = main